export default {
  type: 'table',
  title: `Table`,
  icon: `th`,
  interfaceApi: '/ellipsisone/table.html',
  template: `<table class="table-feature">
              <thead>
                <tr>
                  <th
                    data-placeholder="heading"
                    feature-obj="feature"
                    org-index="orgIndex"
                    ng-repeat="th in feature.header track by $index"
                    contenteditablebind
                    ng-model="th.content"
                    contenteditable="true">{{th.content}}</th>
                </tr>
              </thead>
              <tbody>
                <tr ng-repeat="tr in feature.rows track by $index" model="tr">
                  <td
                    data-placeholder="cell"
                    feature-obj="feature"
                    org-index="orgIndex"
                    ng-repeat="td in tr track by $index"
                    contenteditablebind
                    ng-model="td.content"
                    contenteditable="true">{{td.content}}</td>
                </tr>
              </tbody>
            </table>`,
  setIds: function (idFactory, feature) {
    feature.header.forEach((th) => {
      if (!th._id) {
        th._id = idFactory()
      }
    })
    feature.rows.forEach((row) => {
      row.forEach((td) => {
        if (!td._id) {
          td._id = idFactory()
        }
      })
    })
  },
  onPaste: function (elem) {
    const baseObj = {
      type: 'table',
      header: [],
      rows: [],
    }

    elem.find('thead tr th').each(function () {
      baseObj.header.push({
        type: 'text',
        content: $(this).html(),
      })
    })

    elem.find('tbody tr').each(function () {
      baseObj.rows.push({
        type: 'text',
        content: $(this).html(),
      })
    })
    return baseObj
  } /* ,
    customHandleButtons : [{
        className: 'fa fa-arrow-left',
        event: 'insert-column-left',
        tooltip: 'Insert column left'
      },{
        className: 'fa fa-arrow-right',
        event: 'insert-column-right',
        tooltip: 'Insert column right'
      },{
        className: 'fa fa-remove',
        event: 'delete-column',
        tooltip: 'Delete column'
      },{
        className: 'fa fa-arrow-up',
        event: 'insert-row-above',
        tooltip: 'Insert row above'
      },{
        className: 'fa fa-arrow-down',
        event: 'insert-row-below',
        tooltip: 'Insert row below'
      },
          {
        className: 'fa fa-remove',
        event: 'delete-row',
        tooltip: 'Delete row'
      }
    ] */,
}
